import { type PropsWithChildren, useMemo } from "react";

import { ShellLayoutContext, type ShellLayoutContextValue } from "./context";
import { resolveShellVars } from "./defaults";

export const Root = ({
  children,
  dockMode,
  conversationPanelState,
  conversationPanelWidth,
  isLeftSidebarVisible,
  leftSidebarWidth,
  isRightSidebarVisible,
  rightSidebarWidth,
  onConversationPanelWidthChange,
}: Readonly<PropsWithChildren<ShellLayoutContextValue>>) => {
  const value = useMemo<ShellLayoutContextValue>(
    () => ({
      dockMode,
      conversationPanelState,
      conversationPanelWidth,
      isLeftSidebarVisible,
      leftSidebarWidth,
      isRightSidebarVisible,
      rightSidebarWidth,
      onConversationPanelWidthChange,
    }),
    [
      dockMode,
      conversationPanelState,
      conversationPanelWidth,
      isLeftSidebarVisible,
      leftSidebarWidth,
      isRightSidebarVisible,
      rightSidebarWidth,
      onConversationPanelWidthChange,
    ],
  );

  const style = useMemo(() => resolveShellVars(dockMode), [dockMode]);

  return (
    <ShellLayoutContext.Provider value={value}>
      <div
        data-testid="circle-ai-shell-layout-root"
        className="flex h-svh max-h-full min-h-0 w-full flex-col overflow-hidden"
        style={style}
      >
        {children}
      </div>
    </ShellLayoutContext.Provider>
  );
};

Root.displayName = "CircleAIAppShell.Layout";
